export interface Star {
  id: string;
  name: string;
  avatar: string;
  birthday: string;
  constellation: string;
  birthYear: number;
  nationality: string;
  profession: string;
  height: string;
  debut: string;
  bio: string;
  tags: string[];
  representativeWorks: string[];
  timeline: { year: string; event: string }[];
}

export const stars: Star[] = [
  {
    id: 's01',
    name: '河北彩花',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20an%20elegant%20young%20woman%2C%20soft%20neutral%20light%20blue%20background%2C%20natural%20confident%20expression%2C%20editorial%20headshot%20photography%2C%20high%20detail%2C%20clean%20minimal%20aesthetic%2C%20no%20text&width=640&height=640&seq=hebeistar-avatar-01&orientation=squarish',
    birthday: '3月12日',
    constellation: '双鱼座',
    birthYear: 1998,
    nationality: '日本',
    profession: '演员',
    height: '162cm',
    debut: '2019年',
    bio: '河北彩花，日本影视演员。以细腻克制的表演风格受到关注，擅长塑造内心层次丰富的都市女性角色。自2019年正式进入影视行业以来，先后参演多部电影与电视剧，在悬疑、文艺与都市题材中均有稳定表现，被视为近年上升势头明显的实力派演员之一。',
    tags: ['影视演员', '都市题材', '文艺片', '悬疑'],
    representativeWorks: ['m01', 'm06', 'm05', 'm12'],
    timeline: [
      { year: '2019', event: '正式进入影视行业，参与首部影视作品拍摄。' },
      { year: '2021', event: '凭借电影《雨季到来之前》获得新锐演员提名。' },
      { year: '2022', event: '主演爱情奇幻电影《星尘之下》，口碑与热度双丰收。' },
      { year: '2023', event: '主演年代电视剧《东京往事》，演技获广泛认可。' },
      { year: '2024', event: '主演科幻电影《光的轨迹》，成为年度讨论度最高的作品之一。' },
    ],
  },
  {
    id: 's02',
    name: '白石怜',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20calm%20young%20woman%2C%20soft%20cool%20grey%20blue%20background%2C%20subtle%20confident%20smile%2C%20editorial%20headshot%20photography%2C%20high%20detail%2C%20clean%20minimal%20aesthetic%2C%20no%20text&width=640&height=640&seq=hebeistar-avatar-02&orientation=squarish',
    birthday: '7月29日',
    constellation: '狮子座',
    birthYear: 1996,
    nationality: '日本',
    profession: '演员',
    height: '165cm',
    debut: '2017年',
    bio: '白石怜，实力派影视演员，以张力十足的台词功底见长。影视作品横跨电影与电视剧，常出演推动剧情走向的关键角色。',
    tags: ['影视演员', '剧情片', '舞台剧'],
    representativeWorks: ['m12', 'm05', 'm01', 'm08'],
    timeline: [
      { year: '2017', event: '以舞台剧演员身份出道，积累大量现场表演经验。' },
      { year: '2021', event: '转入影视领域，参演多部电视剧。' },
      { year: '2023', event: '参演电视剧《东京往事》，角色广受好评。' },
    ],
  },
  {
    id: 's03',
    name: '高桥南',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20lively%20young%20woman%2C%20soft%20warm%20cream%20background%2C%20bright%20friendly%20expression%2C%20editorial%20headshot%20photography%2C%20high%20detail%2C%20clean%20minimal%20aesthetic%2C%20no%20text&width=640&height=640&seq=hebeistar-avatar-03&orientation=squarish',
    birthday: '11月2日',
    constellation: '天蝎座',
    birthYear: 1995,
    nationality: '日本',
    profession: '演员',
    height: '168cm',
    debut: '2016年',
    bio: '高桥南，兼顾电影与电视剧的多栖演员，戏路宽泛，既能驾驭冷峻的悬疑人物，也能演绎轻松的都市角色。',
    tags: ['影视演员', '悬疑', '都市'],
    representativeWorks: ['m01', 'm05', 'm10'],
    timeline: [
      { year: '2016', event: '参演首部电影，正式出道。' },
      { year: '2022', event: '在悬疑题材中完成形象突破。' },
      { year: '2024', event: '参演电影《午夜列车》，再获关注。' },
    ],
  },
  {
    id: 's04',
    name: '中村雅',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20graceful%20young%20woman%2C%20soft%20warm%20beige%20background%2C%20gentle%20composed%20expression%2C%20editorial%20headshot%20photography%2C%20high%20detail%2C%20clean%20minimal%20aesthetic%2C%20no%20text&width=640&height=640&seq=hebeistar-avatar-04&orientation=squarish',
    birthday: '4月18日',
    constellation: '白羊座',
    birthYear: 1997,
    nationality: '日本',
    profession: '演员',
    height: '160cm',
    debut: '2018年',
    bio: '中村雅，以自然松弛的表演风格著称，长期活跃于文艺片与家庭题材，是导演眼中的“细节高手”。',
    tags: ['影视演员', '文艺片', '家庭题材'],
    representativeWorks: ['m02', 'm09', 'm05'],
    timeline: [
      { year: '2018', event: '出演文艺短片后进入影视行业。' },
      { year: '2023', event: '主演电影《海街物语》，表演细腻动人。' },
    ],
  },
  {
    id: 's05',
    name: '木村光',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20bright%20young%20woman%2C%20soft%20light%20blue%20grey%20background%2C%20cheerful%20natural%20expression%2C%20editorial%20headshot%20photography%2C%20high%20detail%2C%20clean%20minimal%20aesthetic%2C%20no%20text&width=640&height=640&seq=hebeistar-avatar-05&orientation=squarish',
    birthday: '9月6日',
    constellation: '处女座',
    birthYear: 1999,
    nationality: '日本',
    profession: '演员',
    height: '163cm',
    debut: '2020年',
    bio: '木村光，新生代演员，以青春题材作品进入大众视野，表演清新自然，是业内看好的潜力新星。',
    tags: ['影视演员', '青春', '爱情'],
    representativeWorks: ['m03', 'm06', 'm12', 'm09'],
    timeline: [
      { year: '2020', event: '通过青春剧集正式出道。' },
      { year: '2024', event: '参演《光的轨迹》，尝试科幻题材。' },
    ],
  },
  {
    id: 's06',
    name: '森川葵',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20an%20elegant%20young%20woman%2C%20soft%20dusty%20rose%20grey%20background%2C%20calm%20thoughtful%20expression%2C%20editorial%20headshot%20photography%2C%20high%20detail%2C%20clean%20minimal%20aesthetic%2C%20no%20text&width=640&height=640&seq=hebeistar-avatar-06&orientation=squarish',
    birthday: '12月24日',
    constellation: '摩羯座',
    birthYear: 1994,
    nationality: '日本',
    profession: '演员',
    height: '167cm',
    debut: '2014年',
    bio: '森川葵，资深影视演员，角色类型跨度极大，从都市剧到年代戏都能精准拿捏，被视为剧组的“定心石”。',
    tags: ['影视演员', '年代戏', '剧情片'],
    representativeWorks: ['m11', 'm04', 'm01'],
    timeline: [
      { year: '2014', event: '以电视剧配角开启演员生涯。' },
      { year: '2023', event: '主演青春剧《春日觉醒》。' },
    ],
  },
  {
    id: 's07',
    name: '藤井翔',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20composed%20young%20man%2C%20soft%20cool%20blue%20grey%20background%2C%20calm%20confident%20expression%2C%20editorial%20headshot%20photography%2C%20high%20detail%2C%20clean%20minimal%20aesthetic%2C%20no%20text&width=640&height=640&seq=hebeistar-avatar-07&orientation=squarish',
    birthday: '1月15日',
    constellation: '摩羯座',
    birthYear: 1995,
    nationality: '日本',
    profession: '演员',
    height: '180cm',
    debut: '2017年',
    bio: '藤井翔，影视男演员，以沉稳的银幕形象受到关注，常与实力派演员合作，出演推动情感与剧情的关键人物。',
    tags: ['影视演员', '剧情片', '悬疑'],
    representativeWorks: ['m04', 'm10', 'm06'],
    timeline: [
      { year: '2017', event: '参演首部电影进入行业。' },
      { year: '2022', event: '主演文艺片《夜色温柔》。' },
    ],
  },
  {
    id: 's08',
    name: '佐佐木凛',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20youthful%20young%20woman%2C%20soft%20warm%20amber%20grey%20background%2C%20warm%20open%20expression%2C%20editorial%20headshot%20photography%2C%20high%20detail%2C%20clean%20minimal%20aesthetic%2C%20no%20text&width=640&height=640&seq=hebeistar-avatar-08&orientation=squarish',
    birthday: '6月3日',
    constellation: '双子座',
    birthYear: 1997,
    nationality: '日本',
    profession: '配音演员',
    height: '161cm',
    debut: '2019年',
    bio: '佐佐木凛，影视演员兼配音演员，声音辨识度高，在青春与家庭题材中塑造了多个令人印象深刻的配角。',
    tags: ['影视演员', '配音', '青春'],
    representativeWorks: ['m03', 'm07', 'm11'],
    timeline: [
      { year: '2019', event: '以配音工作出道，后转向影视表演。' },
      { year: '2023', event: '参演青春剧《春日觉醒》。' },
    ],
  },
];